function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3931",
    d: "M6 6V9",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1469",
    d: "M6 9C5.16318 9 4.43485 9.50602 4.05883 10.2525C3.87923 10.609 4.13694 11 4.47939 11H7.52061C7.86306 11 8.12077 10.609 7.94117 10.2525C7.56515 9.50602 6.83682 9 6 9Z",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1470",
    d: "M2.5 2.5H1.99235C1.49909 2.5 1.25246 2.5 1.10008 2.68526C0.947705 2.87053 0.992391 3.07799 1.08176 3.4929C1.25247 4.28543 1.62274 4.9817 2.12445 5.5",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1471",
    d: "M9.5 2.5H10.0076C10.5009 2.5 10.7475 2.5 10.8999 2.68526C11.0523 2.87053 11.0076 3.07799 10.9182 3.4929C10.7475 4.28543 10.3773 4.9817 9.87555 5.5",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1468",
    d: "M6 6C7.933 6 9.5 4.44155 9.5 2.51911C9.5 2.4687 9.49892 2.41853 9.49679 2.36865C9.47542 1.86903 9.46474 1.61922 9.12614 1.30961C8.78754 1 8.41237 1 7.66202 1H4.33798C3.58763 1 3.21246 1 2.87386 1.30961C2.53526 1.61922 2.52458 1.86903 2.50321 2.36865C2.50108 2.41853 2.5 2.4687 2.5 2.51911C2.5 4.44155 4.067 6 6 6Z",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.11f32e498009c57aeca1e41c303fbd8c.svg";
export { ForwardRef as ReactComponent };